var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: { "wide-panel": _vm.bindEmail } },
    [
      _c("GSLabelHighlight", {
        staticClass: "verify-description",
        attrs: {
          text: _vm.getDescriptionText(),
          highlitedText: _vm.getHighlightedText(),
          delimiter: _vm.getDescriptionDelimiter()
        }
      }),
      _vm._v(" "),
      _vm.bindPhone
        ? _c(
            "div",
            [
              _c("GSInputButton", {
                attrs: {
                  placeholder: _vm.$t("lbl__input_verification_code"),
                  text: _vm.resendButtonText,
                  buttonDisabled: _vm.resendDisabled
                },
                on: { clicked: _vm.resend, changed: _vm.updateInputOtp }
              }),
              _vm._v(" "),
              _c("GSButton", {
                staticClass: "submit-button",
                attrs: { text: _vm.$t("btn__submit") },
                on: { clicked: _vm.submit }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.bindEmail
        ? _c("GSSplitView", [
            _c(
              "div",
              { attrs: { slot: "left" }, slot: "left" },
              [
                _c(
                  "div",
                  { staticClass: "verify-content" },
                  [
                    _c("GSInputButton", {
                      attrs: {
                        placeholder: _vm.$t("lbl__input_verification_code"),
                        text: _vm.resendButtonText,
                        buttonDisabled: _vm.resendDisabled
                      },
                      on: { clicked: _vm.resend, changed: _vm.updateInputCode }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("GSButton", {
                  staticClass: "submit-button",
                  attrs: { text: _vm.$t("btn__submit") },
                  on: { clicked: _vm.submit }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { attrs: { slot: "right" }, slot: "right" },
              [
                _c(
                  "div",
                  { staticClass: "verify-content" },
                  [
                    _c("GSLabel", {
                      attrs: { text: _vm.$t("lbl__clicked_link_in_email") }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("GSButton", {
                  staticClass: "submit-button",
                  attrs: { text: _vm.$t("btn__continue") },
                  on: { clicked: _vm.email_continue }
                })
              ],
              1
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("GSAgreement", {
        attrs: {
          text: _vm.$t("lbl__user_agreement_{privacy_policy}"),
          privacyPolicy: _vm.$t("lbl__privacy_policy")
        },
        on: { clicked: _vm.showPolicyPopup }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4a56ce06", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a56ce06","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bind/VerifyPage.vue
// module id = null
// module chunks = 